// ./context/message/messageInitialState.js

export default {
    // FCM Token Management
    registeredUsers: [],
    userToken: null,
    
    // Messages
    messages: [],
    currentConversation: null,
    messageInfo: null,
    
    // Unread Counts
    unreadCount: 0,
    usersWithUnreadCounts: [],
    totalUnreadCount: 0,
    countsBySender: {},
    usersWithUnreadMessages: [],
    
    // Pagination
    totalMessages: 0,
    currentPage: 1,
    totalPages: 1,
    
    // Admin Data
    registeredTokensInfo: null,
    validationResults: null,
    testResults: null,
    
    // Multicast
    lastMulticastResult: null,
    
    // UI State
    isLoading: false,
    error: null,
    lastSentMessage: null
}